import { useRef, useEffect, useState, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { getWidgetStyles } from '../theme'

interface ShadowRootProps {
  children: ReactNode
}

export function ShadowRoot({ children }: ShadowRootProps) {
  const hostRef = useRef<HTMLDivElement>(null)
  const [mountPoint, setMountPoint] = useState<HTMLElement | null>(null)

  useEffect(() => {
    const host = hostRef.current
    if (!host || host.shadowRoot) return

    const shadow = host.attachShadow({ mode: 'open' })

    const style = document.createElement('style')
    style.textContent = getWidgetStyles()
    shadow.appendChild(style)

    const mount = document.createElement('div')
    mount.className = 'rqd-root'
    shadow.appendChild(mount)

    setMountPoint(mount)
  }, [])

  return (
    <div ref={hostRef}>
      {mountPoint && createPortal(children, mountPoint)}
    </div>
  )
}
